webpackJsonp([114276838955818,60335399758886],{

/***/ 115:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(228);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(115);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.141e4abb.png";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styles: home.styl
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Menu.prototype.toggleMenu = function toggleMenu() {
	    var hamburger = document.querySelector('.nav-hamburger');
	    var menu = document.querySelector('.menu');
	    var links = document.querySelectorAll('.menu a');
	
	    hamburger.classList.toggle('nav-hamburger-open');
	    menu.classList.toggle('menu-open');
	    links.forEach(function (link) {
	      link.classList.toggle('link-open');
	    });
	  };
	
	  Menu.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'menu' },
	      _react2.default.createElement('div', { className: 'layer' }),
	      _react2.default.createElement(
	        'a',
	        { href: '#our-story', onClick: this.toggleMenu },
	        'Our Story'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#our-values', onClick: this.toggleMenu },
	        'Our Values & Mission'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#our-model', onClick: this.toggleMenu },
	        'Our Model'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#our-services', onClick: this.toggleMenu },
	        'Spectrum of Services'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#highlighted-projects', onClick: this.toggleMenu },
	        'Highlighted Projects'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#team', onClick: this.toggleMenu },
	        'Meet the Team'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#contact-us', onClick: this.toggleMenu },
	        'Contact Us'
	      )
	    );
	  };
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(489);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styles: nav.styl
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nav.prototype.toggleMenu = function toggleMenu() {
	    var hamburger = document.querySelector('.nav-hamburger');
	    var menu = document.querySelector('.menu');
	    var links = document.querySelectorAll('.menu a');
	
	    hamburger.classList.toggle('nav-hamburger-open');
	    menu.classList.toggle('menu-open');
	    links.forEach(function (link) {
	      link.classList.toggle('link-open');
	    });
	  };
	
	  Nav.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'nav' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/', exact: true },
	        _react2.default.createElement('img', { className: 'nav-logo', src: _logo2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'nav-hamburger', onClick: this.toggleMenu },
	        _react2.default.createElement('span', null),
	        _react2.default.createElement('span', null),
	        _react2.default.createElement('span', null),
	        _react2.default.createElement('span', null)
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styles: page.styl
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'page' },
	      this.props.children
	    );
	  };
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nav = __webpack_require__(225);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _page = __webpack_require__(226);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _menu = __webpack_require__(224);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	__webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(333);
	__webpack_require__(332);
	
	exports.default = function (_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_nav2.default, null),
	        _react2.default.createElement(
	            _page2.default,
	            null,
	            children()
	        ),
	        _react2.default.createElement(_menu2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-29cd497d7101fbad947d.js